/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, recent: NonNullable<unknown> }} Partner_Orgs_SummaryInputs */



/**
* | output |
* | --- |
* | "{total} organizations · {recent} new in the last 30 days" |
*
* @param {Partner_Orgs_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_orgs_summary = /** @type {((inputs: Partner_Orgs_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Orgs_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.total} Organisationen · ${i?.recent} neu in den letzten 30 Tagen`)
	return /** @type {LocalizedString} */ (`${i?.total} organizations · ${i?.recent} new in the last 30 days`)
});